// state/routeActions.js

// Loading actions
export const setLoading = (isLoading) => ({
  type: 'SET_LOADING',
  payload: isLoading
});

// Core data actions
export const setRoutes = (routeData) => ({
  type: 'SET_ROUTES',
  payload: routeData
});

export const setCrews = (crews) => ({
  type: 'SET_CREWS',
  payload: crews
});

export const setWeeklyHours = (hours) => ({
  type: 'SET_WEEKLY_HOURS',
  payload: hours
});

export const setUnassignedJobs = (jobs) => ({
  type: 'SET_UNASSIGNED_JOBS',
  payload: jobs
});

export const setFilteredMarkers = (markers) => ({
  type: 'SET_FILTERED_MARKERS',
  payload: markers
});

// Selection/filter actions
export const selectCrew = (crew) => ({
  type: 'SELECT_CREW',
  payload: crew
});

export const setActiveMarker = (marker) => ({
  type: 'SET_ACTIVE_MARKER',
  payload: marker
});

export const setHighlightedStop = (stop) => ({
  type: 'SET_HIGHLIGHTED_STOP',
  payload: stop
});
export const updateFilters = (filterUpdates) => ({
  type: 'UPDATE_FILTERS',
  payload: filterUpdates
});

// UI actions
export const updateUI = (uiUpdates) => ({
  type: 'UPDATE_UI',
  payload: uiUpdates
});

// Complex actions
export const assignJobSuccess = (assignmentData) => ({
  type: 'ASSIGN_JOB_SUCCESS',
  payload: assignmentData
});

export const unassignJobSuccess = (unassignmentData) => ({
  type: 'UNASSIGN_JOB_SUCCESS',
  payload: unassignmentData
});

export const resetFilters = () => ({
  type: 'RESET_FILTERS'
});

export const updateJobDetails = (details) => ({
  type: 'UPDATE_JOB_DETAILS',
  payload: details
});

// Thunk-like action creators (for complex operations)
export const assignJob = (dispatch, jobData) => async (routeService, notificationService) => {
  dispatch(setLoading(true));
  try {
    const result = await routeService.assignSiteToCrew(jobData);
    dispatch(assignJobSuccess(result));
    notificationService.success('Job assigned successfully');
    return result;
  } catch (error) {
    notificationService.error(`Failed to assign job: ${error.message}`);
    throw error;
  } finally {
    dispatch(setLoading(false));
  }
};

export const unassignJob = (dispatch, jobData) => async (routeService, notificationService) => {
  dispatch(setLoading(true));
  try {
    const result = await routeService.unassignSiteFromCrew(jobData);
    dispatch(unassignJobSuccess(result));
    notificationService.success('Job unassigned successfully');
    return result;
  } catch (error) {
    notificationService.error(`Failed to unassign job: ${error.message}`);
    throw error;
  } finally {
    dispatch(setLoading(false));
  }
};

export const cacheRouteData = (key, data) => ({
  type: 'CACHE_ROUTE_DATA',
  payload: { key, data }
});

export const cacheSiteDetails = (siteId, data) => ({
  type: 'CACHE_SITE_DETAILS',
  payload: { siteId, data }
});

export const clearRouteCache = () => ({
  type: 'CLEAR_ROUTE_CACHE'
});

export const clearSiteCache = (siteId) => ({
  type: 'CLEAR_SITE_CACHE',
  payload: { siteId }
});

export const clearExpiredCache = () => ({
  type: 'CLEAR_EXPIRED_CACHE'
});
